<template>
    <div>
        <div v-if="!!filteredBehaviors.length || !!search" class="input-container">
            <div class="input-box"><input v-model="search" type="text" placeholder="Quick Search"><span class="fa fa-search"></span></div>
        </div>
        <div class="list-container">
            <div class="table">
                <div v-if="!!filteredBehaviors.length" class="row">
                    <div class="cell max-width-50"><a href="" class="point-up">Behavior Description<span class="fa fa-angles-down"></span></a></div>
                    <div class="cell"><a href="" class="point-down">Level</a></div>
                    <div class="cell align-center"><a href="" class="point-down">Tags</a></div>
                    <div v-if="!inKidMode" class="cell align-right"></div>
                </div>
                <div v-for="behavior in filteredBehaviors" class="row">
                    <div class="cell max-width-50">{{ behavior.description }}</div>
                    <div class="cell"><span class="status-bubble" :class="levelClass(behavior.level)">{{ behavior.level }}</span></div>
                    <div class="cell align-center"><span v-for="tag in behavior.tags" :key="`behavior-${ behavior.id }-tag-${ tag.name }`" class="tag-bubble grey-bg">{{ tag.name }}</span><span v-if="behavior.tags.length === 0" class="tag-bubble grey-bg">None</span></div>
                    <div v-if="!inKidMode" class="cell align-right">
                        <div class="buttons"><delete-button @deleted="deleteBehavior(behavior)">
                            <a :href="`/tracker/behaviors/${ behavior.id }/edit`" class="neutral-bg">Update<span class="fa fa-wrench"></span></a>
                        </delete-button></div>
                    </div>
                </div>
                <nothing-here v-if="!filteredBehaviors.length" :is-filtered="search.length > 0"></nothing-here>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LevelsMixin from '@/mixins/LevelsMixin';

export default {

    props: [ 'behaviors' ],

    mixins: [ LevelsMixin ],

    data() {
        return {
            search: '',
        };
    },

    computed: {
        ...mapGetters([ 'child', 'inKidMode' ]),

        filteredBehaviors() {
            if (!this.search || this.search.length === 0) return this.behaviors;

            return this.behaviors.filter(behavior => {
                return behavior.description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
                    behavior.tags.filter(tag => tag.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1).length > 0;
            });
        }

    },

    methods: {

        async deleteBehavior(behavior) {
            await axios.post('/tracker/behaviors/' + behavior.id, { _method: 'DELETE' });

            window.location.reload();
        },

    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/tracker/Behaviors.vue